export default __webpack_public_path__ + "media/method-selector.266dbae49ad973a43ad8cae5aac2ed2c.webp";